// Khen thưởng - Kỉ luật export copy, with its two typos corrected; multi-select, see board/panels/conductEntry.ts.
export const REASON_PRESETS = {
  commendation: [
    'Em học tập tốt',
    'Em rất tích cực phát biểu',
    'Em có tiến bộ rõ rệt',
    'Em đã tham gia hoạt động và giúp đỡ bạn trong lớp',
    'Em đã hoàn thành xuất sắc nhiệm vụ',
    'Chăm chỉ, nỗ lực',
  ],
  violation: [
    'Em chưa tích cực tham gia lớp học',
    'Em không có tinh thần xây dựng bài trong lớp',
    'Em chưa nỗ lực trong học tập',
    'Em thiếu bài tập về nhà',
    'Em không trả lời được câu hỏi',
    'Em chưa làm bài',
  ],
} as const;
